// Portfolio Data
const baseURL = 'https://raw.githubusercontent.com/Iamabdulquddus/arkidu-images/main/';

const portfolioData = [
  {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/1.png',
    category: 'website_development',
    // details: {
    //   description: 'Beautifully designed recipe collection with stunning visuals.'
    // },
  },
  {
    title: 'Brand Social',
    src: baseURL + 'WEBSITE%20PORTFOLIO/2.png',
    category: 'website_development',
    
  },
  {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/3.png',
    category: 'website_development',
    
  },
  {
    id: 4,
    title: 'Syeen ',

    src: baseURL + 'WEBSITE%20PORTFOLIO/4.png',
    category: 'website_development',
    
  },
  {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/5.png',
    category: 'website_development',
    
  },
   {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/6.jpg',
    category: 'website_development',
    
  },
   {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/7.jpg',
    category: 'website_development',
    
  },
   {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/8.jpg',
    category: 'website_development',
    
  },
   {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/9.jpg',
    category: 'website_development',
    
  },
   {
    title: 'Syeen ',
    src: baseURL + 'WEBSITE%20PORTFOLIO/10.jpg',
    category: 'website_development',
    
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/1.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/2.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/3.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/4.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/5.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/6.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/7.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/8.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/9.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/10.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/12.png',
    category: 'ebook_designs',
  },
   {
    title: 'Ebook',
    src: baseURL + 'E-Book%20PORTFOLIO%20/11.png',
    category: 'ebook_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/1.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/2.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/3.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/4.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/5.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/6.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/7.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/8.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/9.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/10.png',
    category: 'flyers_designs',
  },
   {
    title: 'Flyer',
    src: baseURL + 'FLYERS%20PORTFOLIO/11.png',
    category: 'flyers_designs',
  },
  {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/1.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/2.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/3.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/4.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/5.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/6.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/7.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/8.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/9.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/10.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/11.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/12.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/13.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/14.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/15.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/16.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/17.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/18.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/19.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/20.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/21.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'POWERPOINT%20PRESENTATION%20PORTFOLIO/22.png',
    category: 'presentation_designs',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/1.png',
    category: 'youtube_thumbnails',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/2.png',
    category: 'youtube_thumbnails',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/3.png',
    category: 'youtube_thumbnails',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/4.png',
    category: 'youtube_thumbnails',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/5.png',
    category: 'youtube_thumbnails',
  },
   {
    title: '',
    src: baseURL + 'YOUTUBE%20THUMBNAILS/6.png',
    category: 'youtube_thumbnails',
  },
  {
    title: '',
    src: baseURL + 'mobile/1.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/2.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/3.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/4.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/5.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/6.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/7.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/8.jpg',
    category: 'mobile_app_designs',
  },
  {
    title: '',
    src: baseURL + 'mobile/9.jpg',
    category: 'mobile_app_designs',
  },
   {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/1.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/2.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/3.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/4.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/5.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/6.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/7.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/8.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/9.jpg',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/10.png',
    category: 'logo_designs',
  },
  {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/11.png',
    category: 'logo_designs',
  },
   {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/12.png',
    category: 'logo_designs',
  },
   {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/13.png',
    category: 'logo_designs',
  },
   {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/14.jpg',
    category: 'logo_designs',
  },
   {
    title: '',
    src: baseURL + 'LOGO%20PORTFOLIO/15.png',
    category: 'logo_designs',
  },

];

export default portfolioData;